import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    confirmText: { type: String, default: "Click To Confirm" },
    timeout: { type: Number, default: 3000 }
  }

  connect() {
    this.originalText = this.element.textContent
    this.state = "idle"
    this.boundReset = () => {
      if (this.state === "submitting") this.reset()
    }
    document.addEventListener("turbo:before-stream-render", this.boundReset)
  }

  disconnect() {
    clearTimeout(this.resetTimeout)
    document.removeEventListener("turbo:before-stream-render", this.boundReset)
  }

  click(event) {
    if (this.state === "idle") {
      event.preventDefault()
      event.stopImmediatePropagation()
      this.startCountdown()
    } else if (this.state === "counting") {
      event.preventDefault()
      event.stopImmediatePropagation()
      // Ignore clicks during countdown
    } else if (this.state === "ready") {
      // Let the action proceed, show spinner
      this.showSpinner()
    } else if (this.state === "submitting") {
      event.preventDefault()
      event.stopImmediatePropagation()
    }
  }

  startCountdown() {
    this.state = "counting"
    this.element.style.width = `${this.element.offsetWidth}px`
    let count = 3

    const tick = () => {
      if (count > 0) {
        this.element.textContent = `${count}`
        count--
        setTimeout(tick, 500)
      } else {
        this.element.textContent = this.confirmTextValue
        this.state = "ready"
        this.resetTimeout = setTimeout(() => this.reset(), this.timeoutValue)
      }
    }

    tick()
  }

  showSpinner() {
    clearTimeout(this.resetTimeout)
    this.state = "submitting"
    this.element.innerHTML = `<svg data-controller="spinner" class="h-5 w-5"></svg>`
  }

  reset() {
    this.element.textContent = this.originalText
    this.element.style.width = ""
    this.state = "idle"
    clearTimeout(this.resetTimeout)
  }
}
